export enum DemoParam {
    ConfigId = "cid",
    AdId = "aid",
    Capping = "cap",
    CdnSource = "src"
}
